<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="merchants"
      item-key="nmid"
      :options.sync="options"
      :server-items-length="totalMerchants"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="id"
      fixed-header
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.source_onboarding"
              :items="sourceOnboardingList"
              label="Source Onboarding"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_name"
              type="text"
              label="Nama Aggregator"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.nmid"
              type="text"
              label="NMID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.address"
              type="text"
              label="Alamat Lengkap"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.merchant_criteria"
              :items="listMerchantCriteria"
              label="Kriteria Merchant"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mobile_phone"
              type="text"
              label="No. Handphone"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.qr_type"
              :items="listQrType"
              label="Jenis QR"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.sn"
              type="text"
              label="Serial Number"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Tanggal Active"
                  v-bind="attrs"
                  @blur="search.created_at = parseDate(dateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                />
              </template>
              <v-date-picker
                v-model="search.created_at"
                no-title
                @input="dateMenu = false"
                scrollable
              >
                <v-btn text color="primary" @click="dateMenu = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenuInactive"
              v-model="dateMenuInactive"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormattedInactive"
                  label="Tanggal Inactive"
                  v-bind="attrs"
                  @blur="
                    search.deactivated_at = parseDate(dateFormattedInactive)
                  "
                  v-on="on"
                  hide-details="true"
                  dense
                />
              </template>
              <v-date-picker
                v-model="search.deactivated_at"
                no-title
                scrollable
                @input="dateMenuInactive = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenuInactive = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.status"
              :items="listAccountStatus"
              label="Status"
              item-text="text"
              item-value="value"
              @change="getData"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <template>
            <v-btn
              color="primary"
              dark
              :style="{ 'margin-right': '10px' }"
              class="mb-2"
              @click="registerOutlet"
              v-if="idAggregator != null"
            >
              New Outlet
            </v-btn>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              :style="{
                cursor: 'pointer',
                'margin-right': '10px',
              }"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="exportItem()">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer', backgroundColor: index % 2 === 0 ? '#EEEEEE' : '#FFF', }"
          :class="selectedRow === index ? 'indigo lighten-4' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.source_onboarding_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.nmid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.address }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_criteria }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mobile_phone }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.qr_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.sn }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.created_at }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.deactivated_at }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="viewItem(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>View Merchant</v-list-item-title>
                </v-list-item>
                <v-list-item  @click="openSerialNumberDialog(item)">
                <v-list-item-icon>
                  <v-icon>{{ serialIcon(item) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ serialTitle(item) }}
                </v-list-item-title>
              </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>
    <serial-number-dialog
        :title="dialogTitle"
        :value="dialog"
        :formData="formSn"
        :loading="loading"
        :mode="mode"
        @input="dialog = $event"
        @cancel="cancel"
        @save="save"
      />
  </v-card>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataListAccountStatus,
  dataAllQrType,
  dataSourceOnboardingList,
} from '../../../store/params';
import { date } from '../../../lib/helpers';

export default {
  components: {
    SerialNumberDialog: () => import('../../../components/SerialNumberDialog.vue'),
  },
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        width: '10',
        sortable: false,
      },
      {
        text: 'Source Onboarding',
        value: 'source_onboarding',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Nama Merchant',
        value: 'merchant_name',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'NMID',
        value: 'nmid',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Alamat Lengkap',
        value: 'address',
        width: '250',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Kriteria Merchant',
        value: 'merchant_criteria',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'No. Handphone',
        value: 'mobile_phone',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Jenis QR',
        value: 'qr_type',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Serial Number',
        value: 'sn',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Tanggal Active',
        value: 'created_at',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Tanggal Inactive',
        value: 'deactivated_at',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Action',
        value: 'actions',
        align: 'center',
        width: '50',
        sortable: false,
      },
    ],
    editedIndex: -1,
    search: {
      source_onboarding: '',
      merchant_name: '',
      mid: '',
      nmid: '',
      mpan: '',
      qr_type: '',
      sn: '',
      deactivated_at: null,
      mobile_phone: '',
      merchant_criteria: '',
      address: '',
      status: '',
      created_at: null,
    },
    selectedRow: '',
    listMerchantCriteria: dataListMerchantCriteria,
    listAccountStatus: dataListAccountStatus,
    listQrType: dataAllQrType,
    dateFormatted: '',
    dateMenu: false,
    dateFormattedInactive: '',
    dateMenuInactive: false,
    sourceOnboardingList: dataSourceOnboardingList,
    formSn: {
      mid: '',
      merchant_name: '',
      sn: ''
    }
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.inputer.aggregator.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.inputer.aggregator.flashError;
      },
      set() {
        this.$store.commit('inputer/aggregator/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.inputer.aggregator.errors;
    },
    loading() {
      return this.$store.state.inputer.aggregator.loading;
    },
    merchants() {
      return this.$store.state.inputer.aggregator.allMerchants;
    },
    totalPage() {
      return this.$store.state.inputer.aggregator.totalPage;
    },
    totalMerchants() {
      return this.$store.state.inputer.aggregator.totalMerchants;
    },
    bulkAddLink() {
      if (this.idAggregator != null) {
        return `/inputer/aggregator/${this.$route.params.idAggregator}/sub-merchant/${this.$route.params.id}/list-outlet/add-outlet/bulk-upload`;
      }
      return '';
    },
    bulkUpdateLink() {
      if (this.idAggregator != null) {
        return `/inputer/aggregator/${this.$route.params.idAggregator}/sub-merchant/${this.$route.params.id}/list-outlet/update-outlet/bulk-upload`;
      }
      return '';
    },
    idAggregator() {
      return this.$route.params.idAggregator;
    },
    dialogTitle() {
      return this.formSn.sn ? 'Edit Serial Number' : 'Add Serial Number';
    },
    mode() {
      return this.formSn.sn ? 'edit' : 'add';
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },

    'search.deactivated_at': {
      handler() {
        this.dateFormattedInactive = this.formatDate(
          this.search.deactivated_at
        );
        this.getData();
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  async mounted() {
    this.$store.commit('inputer/aggregator/clearMerchants');
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.source_onboarding = '';
      this.search.merchant_name = '';
      this.search.nmid = '';
      this.search.mpan = '';
      this.search.mobile_phone = '';
      this.search.mid = '';
      this.search.merchant_criteria = '';
      this.search.qr_type = '';
      this.search.sn = '';
      this.search.address = '';
      this.search.status = '';
      this.search.created_at = null;
      this.search.deactivated_at = null;
      this.$nextTick(() => {
        this.getData();
      });
    },

    getData() {
      this.$store.commit('inputer/aggregator/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('inputer/aggregator/fetchMerchants', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          aggregatorId: this.$route.params.idAggregator,
          merchantId: this.$route.params.id,
          action: 'outlet',
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    viewItem(item) {
      this.$router.push({ path: `/inputer/merchant/view/${item.id}` });
    },

    editItem(item) {
      this.$router.push({ path: `/inputer/merchant/update/${item.id}` });
    },

    listItem(item) {
      if (this.idAggregator != null) {
        this.$router.push({
          path: `aggregator/${this.$route.params.idAggregator}/sub-merchant/${item.id}/list-outlet`,
        });
      } else {
        this.$router.push({
          path: `sub-merchant/${item.id}/list-outlet`,
        });
      }
    },

    closeFlash() {
      this.$store.commit('inputer/aggregator/setFlashErrorMessage', '');
    },

    registerAggregator() {
      this.$router.push({ path: '/inputer/aggregator/register' });
    },

    registerOutlet() {
      this.$router.push({
        path: `/inputer/aggregator/${this.idAggregator}/sub-merchant/${this.$route.params.id}/register`,
      });
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    serialIcon(item) {
      return item.sn === null || item.sn === '' ? 'mdi-plus' : 'mdi-pencil';
    },
    serialTitle(item) {
      return item.sn === null || item.sn === '' ? 'Add Serial Number' : 'Edit Serial Number';
    },
    openSerialNumberDialog(item) {
      this.dialog = true;
      this.formSn = {
        id: item.id,
        mid: item.mid,
        merchant_name: item.merchant_name,
        sn: item.sn || '',
      };
    },
    cancel() {
      this.dialog = false;
    },
    async save(formData) {
      try {
        await this.$store.dispatch('inputer/merchant/updateSerialNumber', {
          date,
          account_id: formData.id,
          mid: formData.mid,
          sn: formData.sn,
        });
        this.dialog = false;
        this.getData();
      } catch (error) {
        this.$store.commit('setSnackbar', {
          status: true,
          message: 'Something went wrong!',
          icon: 'mdi-alert-circle',
          color: 'red',
        });
      }
    },
    exportItem() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('inputer/aggregator/exportList', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        view: 'sub-merchant-outlet',
        IDAggregator: '',
        IDMerchant: this.$route.params.id,
      });
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
@media only screen and (min-width: 600px) {
  .fixed-row {
    position: -webkit-sticky;
    position: sticky;
    top: 48px;
    z-index: 1;
    background-color: white;
  }
}
</style>
